import { render, staticRenderFns } from "./DynamicTable.vue?vue&type=template&id=51a59dd4&scoped=true"
import script from "./DynamicTable.vue?vue&type=script&lang=js"
export * from "./DynamicTable.vue?vue&type=script&lang=js"
import style0 from "./DynamicTable.vue?vue&type=style&index=0&id=51a59dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a59dd4",
  null
  
)

export default component.exports